import React from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { getSrcSet } from '../../../DeviationViews/Dumbo/Image/_helpers';
import ImageContent from './ImageContent';
import ZoomModal from './ZoomModal';
import { useImageFile } from './hooks/useImageFile';
import s from './Image.scss';
export const ImageFullView = ({ width, height, deviation, isZoomed, onEnterZoomMode, onExitZoomMode })=>{
    const { file, zoomedFile, isFullscreen, isPixel, drag, dragPreview, canZoom } = useImageFile({
        width,
        height,
        deviation,
        isZoomed
    });
    if (!file) {
        return null;
    }
    var _deviation_title;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isFullscreen && s['fullscreen']),
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(Helmet, null, /*#__PURE__*/ React.createElement("link", {
        rel: "preload",
        href: file.src,
        as: "image",
        fetchpriority: 'high'
    })), isZoomed && zoomedFile && /*#__PURE__*/ React.createElement(ZoomModal, {
        src: zoomedFile.src,
        srcSet: getSrcSet(deviation),
        width: zoomedFile.width,
        height: zoomedFile.height,
        isPixel: isPixel,
        onClose: onExitZoomMode
    }), /*#__PURE__*/ React.createElement("div", {
        ref: drag
    }, /*#__PURE__*/ React.createElement(ImageContent, {
        key: file.src,
        width: width,
        height: height,
        file: file,
        alt: (_deviation_title = deviation.title) !== null && _deviation_title !== void 0 ? _deviation_title : '',
        isPixel: isPixel,
        canZoom: canZoom,
        onZoom: onEnterZoomMode
    })), dragPreview);
};
ImageFullView.displayName = 'ImageFullView';
export default ImageFullView;
